module Tapas.ViewModels {
    export class QuickOrderViewModel extends Tapas.ViewModels.InstantSearchViewModel {
        constructor() {
            super();
            this.AddonQueryString('&View=eCom/Productlist/QuickOrderSearch.cshtml&pagesize=4');
            this.searchQuery('');
        }		
	}
} 

